import { useContext } from "react";
import { userStoreContext } from "../store/userStore";

const truthyEnvValues = new Set(["1", "true", "yes", "on"]);

export function resolveFeatureFlag(
  flag: string,
  {
    envValue,
    isAdmin,
    nodeEnv = process.env.NODE_ENV,
    featureFlags,
  }: {
    envValue?: string;
    isAdmin: boolean;
    nodeEnv?: string;
    featureFlags: Record<string, boolean | undefined>;
  },
): boolean {
  if (envValue && truthyEnvValues.has(envValue.toLowerCase())) {
    return true;
  }

  if (isAdmin && nodeEnv !== "production") {
    return true;
  }

  /**
   * Production admins can render published catalog GLBs without enabling
   * `floorplannerProduct3DAssets` for every entitled user.
   */
  if (isAdmin && flag === "floorplannerProduct3DAssets") {
    return true;
  }

  return featureFlags[flag] === true;
}

export function useFeatureFlag(flag: string): boolean {
  const userStore = useContext(userStoreContext);
  const envKey = `REACT_APP_${flag
    .replace(/([A-Z])/g, "_$1")
    .toUpperCase()}`;
  const envAliases =
    flag === "floorplannerProduct3DAssets"
      ? [
          "REACT_APP_FLOORPLANNER_PRODUCT_3D_ASSETS",
          "REACT_APP_ENABLE_FLOORPLANNER_PRODUCT_3D_ASSETS",
        ]
      : [];
  const envValue =
    process.env[envKey] ??
    process.env[`REACT_APP_ENABLE_${envKey.replace("REACT_APP_", "")}`] ??
    envAliases.map((key) => process.env[key]).find(Boolean);

  return resolveFeatureFlag(flag, {
    envValue,
    isAdmin: userStore.isAdmin,
    nodeEnv: process.env.NODE_ENV,
    featureFlags: userStore.featureFlags,
  });
}
